import React from "react"
import { Lang } from "../const"

const FarsiFooter = () => {
    return (
        <footer>
            <div className="row">
                <div className="col">
                    <a href="/fa/free_lesson">آموزش رایگان</a>
                    <a href="/fa/purchase_course" className="disappear">
                        Purchase Course
                    </a>
                    <a href="/fa/contact"> ارتباط با ما</a>
                    <a href="/fa/aboutus">درباره ما</a>
                    <a href="/fa/terms">قوانین و مقررات</a>
                    <a href="/fa/privacy">حریم شخصی</a>
                </div>
                <div className="col">
                    <a href="https://www.facebook.com/Speak-Georgian-547844045682062" target="_blank">
                        <img src="/img/facebook.png" />
                    </a>
                    <p dir="ltr">
                        Copyright ©2018-<span id="currentYear"></span>
                    </p>
                    <p>
                        تمام حقوق مادی و معنوی مطالب این سایت متعلق به پایگاه SpeakGeorgian.com می باشد. برای استفاده از منابع آن نیاز به اجازه ی کتبی
                        دارید.
                    </p>
                </div>
            </div>
        </footer>
    )
}

const EnglishFooter = () => {
    return <footer>
    <div className="row">
        <div className="col">
            <a href="/free_lesson">Free Lessons</a>
            <a href="/purchase_course" className="disappear">Purchase Course</a>
            <a href="/contact">Contact Us</a>
            <a href="/aboutus">About Us</a>
            <a href="/terms">Terms & Conditions</a>
            <a href="/privacy">Privacy Policy</a>
        </div>
        <div className="col">
            <a href="https://www.facebook.com/Speak-Georgian-547844045682062" target="_blank"><img src="/img/facebook.png"/></a>
            <p>©2018-<span id="currentYear"></span> SpeakGeorgian.com - All Rights Reserved.</p>
        </div>
    </div>
</footer>
}

const Footer = ({ lang }: { lang: Lang }) => {
    if (lang === "fa") return <FarsiFooter />
    else return <EnglishFooter />
}

export default Footer